function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12,10.5857864 L21.2928932,1.29289322 L22.7071068,2.70710678 L13.4142136,12 L22.7071068,21.2928932 L21.2928932,22.7071068 L12,13.4142136 L2.70710678,22.7071068 L1.29289322,21.2928932 L10.5857864,12 L1.29289322,2.70710678 L2.70710678,1.29289322 L12,10.5857864 Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/close.22577873.svg";
export { SvgComponent as ReactComponent };